import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { notifyWarning } from '@/utils/error'

type MembershipPromptReason = 'china-identity-filter' | 'ai-match-points' | 'agent-open-job'

type MembershipPromptOptions = {
  reason: MembershipPromptReason
  pricingTab?: 'pro' | 'business' | 'points'
}

export const useMembershipPrompt = () => {
  const router = useRouter()
  const { t } = useI18n()

  const showMembershipPrompt = async ({ reason, pricingTab = 'pro' }: MembershipPromptOptions) => {
    const message =
      reason === 'agent-open-job'
        ? t('upgrade.agentOpenJobMembershipPrompt')
        : reason === 'ai-match-points'
          ? t('upgrade.aiMatchMembershipPrompt')
          : t('upgrade.chinaIdentityFilterPrompt')

    notifyWarning(t('upgrade.membershipRequiredTitle'), {
      description: message,
      action: {
        label: t('upgrade.goToMembership'),
        onClick: () => {
          void router.push({ name: 'ManagePricing', query: { tab: pricingTab } })
        },
      },
      cancel: {
        label: t('common.cancel'),
        onClick: () => undefined,
      },
    })
  }

  return {
    showMembershipPrompt,
  }
}
